function linearYOnX(a) {
  a.sort(function (c, a) {
    return parseFloat(c.x) - parseFloat(a.x);
  });
  var b,
      d,
      e,
      f,
      g = [],
      h = [],
      j = 0,
      k = 0,
      l = 0,
      o = 0,
      p = a.length,
      i = [];

  for (var _b = 0; _b < a.length; _b++) {
    (e = +a[_b].x, f = +a[_b].y, !(isNaN(e) || isNaN(f))) && (g.push(e), h.push(f));
  }

  p = g.length;

  for (var _b2 = 0; _b2 < p; _b2++) {
    j += g[_b2], k += h[_b2];
  }

  j /= p, k /= p;

  for (var _b3 = 0; _b3 < p; _b3++) {
    l += (g[_b3] - j) * (h[_b3] - k), o += (g[_b3] - j) * (g[_b3] - j);
  }

  return 0 == o ? [[], []] : (b = l / o, d = k - b * j, i.push({
    x: g[0],
    y: b * g[0] + d
  }), i.push({
    x: g[p - 1],
    y: b * g[p - 1] + d
  }), [[], i]);
}

function linearXOnY(a) {
  a.sort(function (c, a) {
    return parseFloat(c.y) - parseFloat(a.y);
  });
  var b,
      d,
      e,
      f,
      g = [],
      h = [],
      j = 0,
      k = 0,
      l = 0,
      o = 0,
      p = a.length,
      i = [];

  for (var _b4 = 0; _b4 < a.length; _b4++) {
    (e = +a[_b4].x, f = +a[_b4].y, !(isNaN(e) || isNaN(f))) && (g.push(e), h.push(f));
  }

  p = g.length;

  for (var _b5 = 0; _b5 < p; _b5++) {
    j += g[_b5], k += h[_b5];
  }

  j /= p, k /= p;

  for (var _b6 = 0; _b6 < p; _b6++) {
    l += (g[_b6] - j) * (h[_b6] - k), o += (h[_b6] - k) * (h[_b6] - k);
  }

  return 0 == o ? [[], []] : (b = l / o, d = j - b * k, i = [], i.push({
    x: b * h[0] + d,
    y: h[0]
  }), i.push({
    x: b * h[p - 1] + d,
    y: h[p - 1]
  }), [[], i]);
}

export default function getLinearRegressionPoints(a, b) {
  return +b ? linearYOnX(a) : linearXOnY(a);
}